
import React from 'react';
import '../index.css';

export default (props: any) => {
  const { title } = props;
  return (
    <div style={{ backgroundColor: '#fff' }}>
      {title && <div className='form-register-title'>{title}</div>}
      {props.children}
    </div>
  )
}